import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(
	theme => ({
		root: {
			display: 'flex',
			alignItems: 'center',
			padding: theme.spacing(2.5),
			borderTop: '1px solid #949699',

			'&:last-child': {
				borderBottom: '1px solid #949699',
			},

			'&:hover': {
				cursor: ({ isBuilderMode }) => (isBuilderMode ? 'default' : 'pointer'),
				borderRadius: ({ isBuilderMode }) => (isBuilderMode ? 8 : null),
			},
		},
		active: {
			borderRadius: 8,
			backgroundColor: '#F2F2F3',
			borderBottom: 'none',
			borderTop: 'none',

			'&$active + $root': {
				borderTop: 'none !important',
			},
			'&:last-child': {
				borderBottom: 'none',
			},
		},
		iconsContainer: {
			width: theme.spacing(2.5),
			marginLeft: theme.spacing(1.5),
		},
		playIcon: {
			marginRight: theme.spacing(1.5),
			fontSize: 14,
			color: ({ active }) => (active ? theme.palette.primary.main : theme.palette.text.secondary),
			flexShrink: 0,
		},
		checkIcon: {
			fontSize: 14,
			color: theme.palette.primary.main,
			width: 28,
			marginRight: -8,
			flexShrink: 0,
		},
		text: {
			width: 1,
			flexGrow: 1,
			color: ({ active }) =>
				active ? theme.palette.calcContrastColor(theme.palette.text.secondary, '#F2F2F3') : null,
			fontWeight: ({ active }) => (active ? '700 !important' : null),
			'&:not(:focus)': {
				display: '-webkit-box',
				overflow: 'hidden',
				'-webkit-line-clamp': 2,
				'-webkit-box-orient': 'vertical',
			},
		},

		equalizer: {
			width: 28,
			height: 27,
			marginRight: -8,
			flexShrink: 0,
		},
	}),
	{ name: 'Video-Video9-item' },
)

export default useStyles
